// Base host of the static assets CDN. Every asset URL built in JS lives here so
// a domain migration is a one-line change instead of a search and replace.
// Plain CSS cannot read this constant, so src/assets/global-styles.css still
// hardcodes the same host for the flags sprite and has to be updated with it.
export const CDN1_BASE = 'https://cdn1.wellet.mx';

export const creditCardLogo = (brand) =>
  `${CDN1_BASE}/images/credit-card/${brand?.toLocaleLowerCase()}-logo.png`;

export const defaultOrganizationLogo = `${CDN1_BASE}/organizations/wellet/logo.png`;
